// eslint-disable-next-line max-classes-per-file
export enum PromotionProductTypeEnum {
  HOTEL = "hotel",
  FLIGHT = "flight",
  HOME = "home",
  TICKET = "ticket",
  CAR = "car",
  TOUR = "tour",
  ALL = "all",
}

export interface RequestPromotionListInterface {
  id: number;
  page: number;
  limit: number;
  type: PromotionProductTypeEnum[] | PromotionProductTypeEnum;
  category?: string[];
  klubCategory?: string;
  airlineSlug?: string;
}

export interface RequestPromotionListV5Interface {
  type: PromotionProductTypeEnum;
}

export interface RequestRoomPromotionInterface {
  bookingInternalNo: string;
  couponCode: string;
  isMobile: number;
}

export class TypePromotion {
  key: string;

  name: string;

  iconInactive: string;

  iconActive: string;

  constructor(data: any) {
    this.key = data.key || "";
    this.name = data.name || "";
    this.iconInactive = data.iconInactive || "";
    this.iconActive = data.iconActive || "";
  }
}

export class CategoryPromotion {
  key: string;

  name: string;

  iconInactive: string;

  iconActive: string;

  constructor(data: any) {
    this.key = data.key || "";
    this.name = data.name || "";
    this.iconInactive = data.iconInactive || "";
    this.iconActive = data.iconActive || "";
  }
}

export class PromotionType {
  key: string;

  name: string;

  promotionTypeKey: string;

  constructor(data: any) {
    this.key = data.key || "";
    this.name = data.name || "";
    this.promotionTypeKey = data.promotion_type_key || "";
  }
}

export class PromotionDetail {
  id: number | string;

  title: string;

  excerpt: string;

  description: string;

  startPrice: number;

  currency: string;

  product: string[];

  promotionTypes: PromotionType[];

  fullImage: string;

  thumbImage: string;

  mobileImage: string;

  homeImage: string;

  startDate: string;

  expireDate: string;

  slug: string;

  url: string;

  subtitle: string;

  constructor(data: any) {
    this.id = data.id || 0;
    this.title = data.title || "";
    this.excerpt = data.excerpt || "";
    this.description = data.description || "";
    this.startPrice = data.startPrice || 0;
    this.currency = data.currency || "";
    this.product = data.product || [];
    this.promotionTypes = data.promotionTypes || [];
    this.fullImage = data.fullImage || "";
    this.thumbImage = data.thumbImage || "";
    this.mobileImage = data.mobileImage || "";
    this.homeImage = data.homeImage || "";
    this.startDate = data.startDate || "";
    this.expireDate = data.expireDate || "";
    this.slug = data.slug || "";
    this.url = data.url || "";
    this.subtitle = data.subtitle || "";
  }
}

export class Promotion {
  discountCoupon: PromotionDetail[];

  partner: PromotionDetail[];

  constructor(data: any) {
    this.discountCoupon = (data.discountCoupon || []).map(
      (discount: any) => new PromotionDetail(discount),
    );

    this.partner = (data.partner || []).map(
      (partnerObj: any) => new PromotionDetail(partnerObj),
    );
  }
}
export class ResponsePromotionList {
  promotions: PromotionDetail[];

  total: number;

  type: TypePromotion[];

  category: CategoryPromotion[];

  constructor(data: any) {
    this.promotions = (data.promotions || []).map(
      (promotion: any) => new PromotionDetail(promotion),
    );

    this.type = (data.type || []).map((type: any) => new TypePromotion(type));
    this.category = (data.category || []).map(
      (category: any) => new CategoryPromotion(category),
    );
    this.total = data.total || 0;
  }
}

export class ResponsePromotionListV5 {
  promotions: Promotion[];

  total: number;

  type: TypePromotion[];

  category: CategoryPromotion[];

  constructor(data: any) {
    this.promotions = (data.promotions || []).map(
      (promotion: any) => new Promotion(promotion),
    );

    this.type = (data.type || []).map((type: any) => new TypePromotion(type));
    this.category = (data.category || []).map(
      (category: any) => new CategoryPromotion(category),
    );
    this.total = data.total || 0;
  }
}
